import axios from 'axios'
import { retryPromise } from '../../../modules/retryPromise'

import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../../modules/mutations.js'

export const companiesStoreGmbLocations = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    formValues: {
      location_ids: []
    },
    polling: false,
  },
  getters: {
    notConnectedLocations(state) {
      if (!state.data) return []

      return state.data.filter(d => !d.attributes.connected)
    }
  },
  mutations: {
    readStoreGmbLocations(state) {
      state.data = null
      state.loading = true
    },
    readStoreGmbLocationsSuccess(state, payload) {
      state.data = payload.data
      state.formValues.location_ids = payload.data.filter(d => !d.attributes.connected).map(v => { return v.id })
      state.loading = false
    },
    readStoreGmbLocationsFailure(state) {
      state.loading = false
    },
    writeStoreGmbLocations(state) {
      state.loading = true
    },
    writeStoreGmbLocationsSuccess(state) {
      state.loading = false
    },
    writeStoreGmbLocationsFailure(state) {
      state.loading = false
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
    setPolling(state, value) {
      state.polling = value
    },
  },
  actions: {
    async readStoreGmbLocations({ commit }, payload) {
      commit('readStoreGmbLocations')
      const retryFunc = () => {
        return axios
          .get('/api/companies/' + payload.companyUuid + '/gmb/accounts/' + encodeURIComponent(payload.accountId) + '/locations.json')
      }

      const evalFunc = (result) => {
        const isPolling = result.data.status === 'processing'
        commit('setPolling', isPolling)
        return !isPolling
      }
      return retryPromise(retryFunc, evalFunc, 5000)
        .then(res => {
          commit('readStoreGmbLocationsSuccess', res.data)
        })
        .catch(err => {
          commit('readStoreGmbLocationsFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    writeStoreGmbLocations({ commit, state }, payload) {
      if (state.loading) return false

      const parameters = {
        location_ids: state.formValues.location_ids ?? []
      }
      let url
      if(payload.viaSelfServe) {
        url = `/api/companies/${payload.companyUuid}/registrations/brands/${payload.brandId}/bulk_creation_store`
      } else {
        url = `/api/companies/${payload.companyUuid}/brands/${payload.brandId}/bulk_creation_store`
      }

      commit('writeStoreGmbLocations')
      return axios
        .post(url, parameters)
        .then(() => {
          commit('writeStoreGmbLocationsSuccess')
          return true
        })
        .catch(err => {
          commit('writeStoreGmbLocationsFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
